import React from 'react'
import { useSelector } from 'react-redux';

import DashEmpresa from './components/DashEmpresa';
import DashCandidato from './components/DashCandidato';

function Inicial() {
    const roleUser = useSelector(state => state.role.role_user)

    return (
        <>
            {roleUser === "User" &&
                <DashCandidato />
            }
            {roleUser === "Company" &&
                <DashEmpresa />
            }
        </>
    );
}
export default Inicial;